import React from "react";
import Drawer from "@material-ui/core/Drawer";
import { Button, Menu } from "semantic-ui-react";
import { MAIN_COLOUR, NAVBAR_STYLES } from "../../css/styles";
import { openModal } from "../../app/common/modals/modalReducer";
import { SIGN_UP_MODAL } from "../../app/common/modals/ModalManager";
import { Link } from "react-router-dom";
import {
  ACCOUNT_SIGN_IN_ROUTE,
  BLOG_ROUTE,
  COMPANIES_ROUTE,
  EMPLOYER_DASHBOARD_POST_JOB_PATH,
  HOME_PAGE_ROUTE,
  PRICING_PATH,
} from "../../app/api/routeConstants";
import CountrySelector from "./CountrySelector";
import Divider from "../../app/common/components/Divider";
import { useDispatch, useSelector } from "react-redux";
import JobsModeSelector from "./JobsModeSelector";

export default function MobileSidebarMenu({ open, toggleShowDrawer }) {
  const dispatch = useDispatch();

  const { currentUserAccount } = useSelector((state) => state.account);

  const toggleDrawer = (show) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    toggleShowDrawer(show);
  };

  function closeSidebar() {
    toggleShowDrawer(false);
  }

  return (
    <Drawer
      anchor={"left"}
      open={open}
      onClose={toggleDrawer(false)}
      transitionDuration={{ enter: 400, exit: 300 }}
    >
      <Menu vertical text style={{ padding: "0 20px", width: "100%" }}>
        <Menu.Menu style={{ border: "none" }}>
          {!currentUserAccount && (
            <Menu.Item style={{ textAlign: "left" }}>
              <Button
                className={"overwrite-button cta-orange"}
                content={"Create account"}
                onClick={() => {
                  closeSidebar();
                  dispatch(openModal({ modalType: SIGN_UP_MODAL }));
                }}
              />
            </Menu.Item>
          )}
          <Menu.Item style={{ textAlign: "left" }}>
            <JobsModeSelector
              navbar={NAVBAR_STYLES.navbarHome}
              textColour={MAIN_COLOUR}
              postHandleClick={closeSidebar}
            />
          </Menu.Item>
          <Menu.Item
            style={{ textAlign: "left" }}
            as={Link}
            to={COMPANIES_ROUTE}
            onClick={closeSidebar}
          >
            <div className="body-blue-text responsive-action-text">
              Companies
            </div>
          </Menu.Item>
          <Menu.Item
            style={{ textAlign: "left" }}
            as={Link}
            to={BLOG_ROUTE}
            onClick={closeSidebar}
          >
            <div className="body-blue-text responsive-action-text">Blog</div>
          </Menu.Item>
          <Menu.Item style={{ textAlign: "left" }}>
            <CountrySelector
              navbar={NAVBAR_STYLES.navbarHome}
              textColour={MAIN_COLOUR}
            />
          </Menu.Item>
          <Menu.Item style={{ textAlign: "left", marginTop: 33 }}>
            <div className="body-blue-text mobile-menu-title">Employers</div>
          </Menu.Item>
          <Divider />
          <Menu.Item
            style={{ textAlign: "left" }}
            as={Link}
            to={PRICING_PATH}
            onClick={closeSidebar}
          >
            <div className="body-blue-text responsive-action-text">Pricing</div>
          </Menu.Item>
          <Menu.Item
            style={{ textAlign: "left" }}
            as={Link}
            to={EMPLOYER_DASHBOARD_POST_JOB_PATH}
            onClick={closeSidebar}
          >
            <div className="body-blue-text responsive-action-text">
              Post a job
            </div>
          </Menu.Item>
          <Menu.Item style={{ textAlign: "left", marginTop: 33 }}>
            <div className="body-blue-text mobile-menu-title">General</div>
          </Menu.Item>
          <Divider />
          <Menu.Item
            style={{ textAlign: "left" }}
            as={Link}
            to={HOME_PAGE_ROUTE}
            onClick={closeSidebar}
          >
            <div className="body-blue-text responsive-action-text">Home</div>
          </Menu.Item>
          {!currentUserAccount && (
            <Menu.Item
              style={{ textAlign: "left", marginTop: 25 }}
              as={Link}
              to={ACCOUNT_SIGN_IN_ROUTE}
              onClick={closeSidebar}
            >
              <div className="body-blue-text responsive-action-text">
                Sign in
              </div>
            </Menu.Item>
          )}
        </Menu.Menu>
      </Menu>
    </Drawer>
  );
}
